// @ts-nocheck


import { EllipsisOutlined } from '@ant-design/icons';
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import { connect } from 'react-redux';

import Menu from 'antd/lib/menu';
import Button from 'antd/lib/button';







import { accessTypeEnum } from './../../../lib/enum';
import {
  applyMaskToValue,
  getListInitialState,
  setQueryParams } from
'./../../../lib/helpers';
import { batteryApi } from './../../../lib/api';


import { Table, Dropdown } from './../../../components/ui';
import { Panel, Section } from './../../../components/layout';
import Header from '../../../components/layout/Header';
import { Crumb } from '../../../components/layout/Breadcrumbs';
import Breadcrumbs from '../../../components/layout/Breadcrumbs';
import NavigationTabs from '../components/NavigationTabs';
import { withUserAccess } from './../../withUserAccess';

import Filter from './Filter';

import CopyBatteryButton from './components/CopyBatteryButton';
import { formatLicensePlateMask } from '../../../components/inputs/masked-inputs/LicensePlateInput';

const StyledPanel = styled(Panel)`
  padding-bottom: 0;
  padding-top: 0;
`;
const PanelTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const canAddBatteryAccess = [
accessTypeEnum.admin,
accessTypeEnum.handlingEquipment];












/** Вывод списка АКБ */
class List extends Component {
  static defaultProps = {
    location: {}
  };

  getDefaultFilter = () => {
    const canViewAll = this.props.userAccess.some((access) =>
    [accessTypeEnum.viewingAllEquipments].includes(access)
    );
    const defaultFilter = canViewAll ?
    { ...null } :
    {
      nodeId: this.props.employeeBranchOrgUnitId,
      nodeFilterType: 'branchAndChildren'
    };
    return defaultFilter;
  };

  state = {
    ...getListInitialState(),
    filter: this.getDefaultFilter()
  };

  dropdown = {};

  fetchBatteries = async (
  page = 1,
  params = {}) =>
  {
    const { filter } = this.state;
    this.setState({ loading: true });
    const { data, totalCount } = await batteryApi.fetchBatteries({
      ...filter,
      page,
      ...params,
      ...this.getDefaultFilter() // фильтр по оргюнитам в зависимости от клэймов
    });
    setQueryParams({ page });
    this.setState({ loading: false, data, totalCount, page });
  };

  renderOverlay = (battery) =>
  <Menu>
      <Menu.Item>
        <CopyBatteryButton
        battery={battery}
        afterSubmit={() => {
          this.fetchBatteries(this.state.page);
          // $FlowFixMe тут id будет всегда
          if (this.dropdown[battery.id]) {
            this.dropdown[battery.id].onVisibleChange(false);
          }
        }} />

      </Menu.Item>
    </Menu>;


  columns = [
  { title: '№', dataIndex: 'id', sorter: true, width: 25 },
  {
    title: 'Марка',
    dataIndex: 'brand',
    sorter: true,
    sorterKey: 'brand'
  },
  { title: 'Наименование', dataIndex: 'name', sorter: true },
  {
    title: 'Гос. номер',
    dataIndex: 'vehicle',
    render: (vehicle) =>
    vehicle?.licensePlate ?
    <Link to={`/vehicles/${vehicle.id}`}>
            {applyMaskToValue(vehicle.licensePlate, formatLicensePlateMask)}
          </Link> :

    '-'

  },
  { title: 'Заводской номер', dataIndex: 'factoryNumber', sorter: true },
  {
    title: '',
    width: '30px',
    // Нужно для того, чтобы не отрабатывал onRow
    onCell: () => ({ onClick: (e) => e.stopPropagation() }),
    render: (record) =>
    <Dropdown
    // $FlowFixMe тут id будет всегда
    ref={(dropdown) => this.dropdown[record.id] = dropdown}
    overlay={this.renderOverlay(record)}>

          <EllipsisOutlined style={{ fontSize: 16, color: '#2770FF' }} />
        </Dropdown>

  }];


  handleRowClick = (id) => navigate(`/equipment/batteries/${id}`);

  cleanFilter = () => this.setState({ filter: { ...null } }, this.fetchBatteries);

  applyFilter = (filter) =>
  this.setState({ filter }, this.fetchBatteries);

  render() {
    const { location, userAccess } = this.props;

    const { data, totalCount, page, pageSize, loading, filter } = this.state;

    const canAdd = userAccess.some((access) =>
    canAddBatteryAccess.includes(access)
    );

    return (
      <Fragment>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb>АКБ</Crumb>
            </Breadcrumbs>
          } />

        <StyledPanel>
          <PanelTitle>
            <h1>АКБ</h1>
            {canAdd &&
            <Link to="/equipment/batteries/new">
                <Button data-cy="addBattery" type="primary">
                  Создать
                </Button>
              </Link>
            }
          </PanelTitle>
          <NavigationTabs defaultTab="batteries" />
        </StyledPanel>
        <Section>
          <Filter
            filter={filter}
            applyFilter={this.applyFilter}
            cleanFilter={this.cleanFilter} />

          <Table
            onRow={(record) => ({
              onClick: () => this.handleRowClick(record.id)
            })}
            loading={loading}
            data={data.map((battery) => ({
              ...battery,
              key: battery.id
            }))}
            fetch={this.fetchBatteries}
            fetchOnMount
            columns={this.columns}
            pagination={{
              page,
              pageSize,
              totalCount,
              location
            }} />

        </Section>
      </Fragment>);

  }
}

export default connect((state) => ({
  employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
}))(withUserAccess(List));
